import axios from 'axios';

export function getAutocheckNMVTISReport(VIN, referenceId, product, config) {
  const headers = {
    'Content-Type': 'application/x-www-form-urlencoded',
    Authorization: `Bearer ${localStorage.getItem('jwtToken')}`,
    'x-location-id': localStorage.getItem('locationId')
};
  const reference = referenceId || '';
  const url = `${config.getNmvtisReportService}?VIN=${VIN}&referenceId=${reference}&product=${product}`;
  return dispatch => dispatch({
    type: 'AUTOCHECK_NMVTIS_FETCH',
    payload: axios({ method: 'get', url, headers })
  }).catch((error) => {
    console.log(error);
  });
}

export function clearAutocheckNMVTISReport() {
  return {
    type: 'AUTOCHECK_NMVTIS_CLEAR',
    payload: ''
  };
}


// WEBPACK FOOTER //
// ./src/actions/getAutocheckNMVTISReport.js